import React from 'react'
import './fileuploader.css'

const FileUpload = ({ uploadHandler }) => {
    const uploadLocalHandler = (e) => {
        e.preventDefault();
        uploadHandler(e.target.files[0])
        e.target.value = null;
    }
    return (
        <>
            <div className="file-card">
                <div className="file-inputs">
                    <input type="file" name="file" id="file" onChange={e => uploadLocalHandler(e)} />
                    <button>
                        <i className="uil uil-plus"></i>
                        Upload
                    </button>
                </div>

                <p className="main">Support files</p>
                <p className="info">JPG, JPEG, PNG</p>
            </div>
        </>
    )

}

export default FileUpload;
